import React from 'react';
import ReactDOM from "react-dom/client";
import App from './App.jsx';
import Application from './Application.js';

const app = new Application();


ReactDOM.createRoot(document.getElementById("root")).render(
   // <React.StrictMode> //load the game page twice and does not unload the first one, why?
      <App application={app} />
   // </React.StrictMode>
);